export default "__VITE_ASSET__B9Z22T3C__"